export const DEFAULT_SEARCH_DETAILS = [
  {
    value: 0,
    key: "Assets",
    highlight: false,
    response: [],
    isApiCall: false,
    data: [],
  },
  {
    value: 0,
    key: "Controls",
    highlight: false,
    response: [],
    isApiCall: false,
    data: [],
  },
  {
    value: 0,
    key: "Resources",
    highlight: false,
    response: [],
    isApiCall: false,
    data: [],
  },
  {
    value: 0,
    key: "Cloud-Controls",
    highlight: false,
    response: [],
    isApiCall: false,
    data: [],
  },
  {
    value: 0,
    key: "Benchmarks",
    highlight: false,
    response: [],
    isApiCall: false,
    data: [],
  },
  {
    value: 0,
    key: "Roles",
    highlight: false,
    response: [],
    isApiCall: false,
    data: [],
  },
  {
    value: 0,
    key: "Scans",
    highlight: false,
    response: [],
    isApiCall: false,
    data: [],
  },
  {
    value: 0,
    key: "Users",
    highlight: false,
    response: [],
    isApiCall: false,
    data: [],
  },
  {
    value: 0,
    key: "Cve",
    highlight: false,
    response: [],
    isApiCall: false,
    data: [],
  },
];

export const tableResponse = {
  Assets: "Assets",
  Parameters: "Controls",
  Benchmarks: "Benchmarks",
  Roles: "Roles",
  Scans: "Scans",
  Users: "Users",
  CVE: "Cve",
  Resources: "Resources",
  CloudControls: "Cloud-Controls",
};

export const tablesObjects = {
  [tableResponse.Assets]: {
    title: "Assets",
    type: tableResponse.Assets,
    url: "on-premises/assets",
  },
  [tableResponse.Scans]: {
    title: "Scans",
    type: tableResponse.Scans,
    url: "onprem/scan",
  },
  [tableResponse.Roles]: {
    title: "Roles",
    type: tableResponse.Roles,
    url: "organization/roles",
  },
  [tableResponse.Benchmarks]: {
    title: "Benchmarks",
    type: tableResponse.Benchmarks,
    url: "on-premises/security-posture",
  },
  [tableResponse.Parameters]: {
    title: "Parameters",
    type: tableResponse.Parameters,
    url: "on-premises/security-posture",
  },
  [tableResponse.Users]: {
    title: "Users",
    type: tableResponse.Users,
    url: "organization/user-management",
  },
  [tableResponse.CVE]: {
    title: "CVE",
    type: tableResponse.CVE,
    url: "on-premises/cve",
  },
  [tableResponse.Resources]: {
    title: "Resources",
    type: tableResponse.Resources,
    url: "cloud/cloud-resources",
  },
  [tableResponse.CloudControls]: {
    title: "Cloud Controls",
    type: tableResponse.CloudControls,
    url: "cloud/security-posture",
  },
};
